import { RegistryOrderShippingAddress } from '@apps/registry/admin/routes/YourRegistry/components/GiftTracker/GiftTracker.types';
import { ShippingAddressFragment, ShippingAddressInput } from '@graphql/generated';

export function shippingAddressFragmentAsInput(shippingAddress: ShippingAddressFragment | null): ShippingAddressInput | null {
  return shippingAddress ? (({ __typename, hash, ...rest }) => rest)(shippingAddress) : null;
}

export function registryOrderShippingAddressAsFragment(shippingAddress: RegistryOrderShippingAddress | null): ShippingAddressFragment | null {
  return shippingAddress
    ? {
        ...shippingAddress,
        address1: shippingAddress?.address1 ?? '',
        address2: shippingAddress?.address2 ?? null,
        city: shippingAddress?.city ?? '',
        state: shippingAddress?.state ?? '',
        country: '', // not available
        validated: false, // not available
      }
    : null;
}

type ShippingFeeInterpretation = {
  isFreeShipping: boolean;
  floatingPointDecimalString: string;
  floatingPointCurrencyString: string;
};
// TODO:  interpretShippingInMinorUnits
export function interpretShippingDecimalString(decimalString: Maybe<string>): ShippingFeeInterpretation {
  if (!decimalString) {
    return {
      // blank does NOT mean free
      isFreeShipping: false,
      floatingPointDecimalString: '',
      floatingPointCurrencyString: '',
    };
  }
  return {
    isFreeShipping: decimalString === '0.00',
    floatingPointDecimalString: decimalString,
    // TODO:  formatCurrency
    floatingPointCurrencyString: '$' + decimalString,
  };
}
